import { useState, useEffect, useRef } from "react"

import moment from "moment"
import { Form } from "react-bootstrap"
import DatePicker from "react-datepicker"
import { Modal, Checkbox, Select, Button, Radio } from "antd"

import { useDispatch, useSelector } from "react-redux"
import { getrpmDeviceActions } from "../../../redux/actions/rpmAction"
import { getProviderList } from "../../../redux/actions/providerAction"
import {
  getPatientInfo,
  postMonitoringData,
  deleteMonitoringData,
  getPatientMonitoringData,
  getPatientDiagnosticsData,
  postPatientDiagnosticsData,
  deletePatientDiagnosticsData,
  getPatientMenuConfigAction
} from "../../../redux/actions/patientAction"

import Autosuggest from "react-autosuggest"

import { FiMinusSquare } from "react-icons/fi"

import Loading from "../../layouts/Loading/Loading"
import { useToasts } from "react-toast-notifications"
import { PATIENT_DIAGNOSTIC_RESET } from "../../../redux/types/PatientConstant"
import { getPractitionerList } from "../../../redux/actions/practitionerAction"
import { useParams } from "react-router-dom"
import FloatInput from "../../../utils/FloatInput/FloatInput"
import { mapDeviceType } from "../../../utils/mapDeviceType"

const CheckboxGroup = Checkbox.Group

const getProviderOption = (arr, identifier) => {
  if (arr) {
    return arr.map(provider => ({
      label: <span className="capitalize">{`${provider?.firstName} ${provider?.middleName ?? ''} ${provider?.lastName}`}</span>,
      value: `${identifier}:${provider.id}`
    }))
  } else {
    return []
  }
}

const getPractitionerOption = (arr, identifier) => {
  if (arr) {
    return arr.map(practitioner => ({
      label: <span className="capitalize">{`${practitioner?.firstName} ${practitioner?.middleName ?? ''} ${practitioner?.lastName}`}</span>,
      value: `${identifier}:${practitioner.id}`
    }))
  } else {
    return []
  }
}

const scrollToElement = (elementRefs, key) => {
  const element = elementRefs?.current[key];
  if (element) {
    element?.input?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }
};

const getSuggestions = async value => {
  const inputValue = value.trim().toLowerCase()
  let response = await fetch(
    `https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=${inputValue}`
  )
  let data = await response.json()
  return data[3]
}

const CCM_DIAGNOSTIC_ERR_MSG = "Minimum 2 diagnostic codes must be selected as per current monitoring type selection"
const PCM_DIAGNOSTIC_ERR_MSG = "Minimum 1 diagnostic code must be selected as per current monitoring type selection"
const SELECT_MONITOR_TYPE_MSG = "Please select the monitoring type"
const SELECT_MONITOR_DEVICE_MSG = "Please select the device for the selected monitoring type"
const MONITORING_DIA_UPDT_MSG = "Monitoring and diagnostics updated"

const UpdateMonitoring = props => {
  const { patientId, updateMonitoringShow, patientMonitoringData, handleUpdateMonitoringClose } =
    props

  const [value, setValue] = useState("")
  const [selectedRPM, setSelectedRPM] = useState([])
  const [customError, setCustomError] = useState([])
  const [diagnostics, setDiagnostics] = useState([])
  const [suggestions, setSuggestions] = useState([])
  const [selectedTypes, setSelectedTypes] = useState([])
  const [diagnosticError, setDiagnosticError] = useState(null)
  const [diagnosticDate, setDiagnosticDate] = useState(new Date())
  const [providerTypeRadio, setProviderTypeRadio] = useState({})
  const [selectedProvider, setSelectedProvider] = useState({})
  const [provider, setProvider] = useState({})
  const [practitioner, setPractitioner] = useState({})
  const [searchText, setSearchText] = useState("")

  const elementRefs = useRef({});

  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const { orgId } = useParams()

  const { providerList } = useSelector(state => state.providerList)
  const { practitionerList } = useSelector(state => state.practitionerList)

  const { loading, error: patientMonitoringError } = useSelector(state => state.patientMonitoringData)
  // const { loading: rpmDeviceLoading, rpmDevices } = useSelector(state => state.rpmDevices)
  const { loading: DiagnosticsLoading, patientDiagnosticData, error: patientDiagnosticsError } = useSelector(
    state => state.patientDiagnosticData
  )
  const { error: diagnosticPostError } = useSelector(state => state.postPatientDiagnosticReducer)
  const rpmDevices = JSON.parse(localStorage.getItem("monitorTypes"))

  const handleClose = () => {
    setDiagnosticError(null)
    // dispatch({ type: PATIENT_DIAGNOSTIC_RESET })
    handleUpdateMonitoringClose()
  }

  useEffect(() => {
    if (updateMonitoringShow) {
      dispatch(getProviderList(orgId))
      dispatch(getPractitionerList(orgId))
      dispatch(getrpmDeviceActions())
      dispatch(getPatientDiagnosticsData({ patientId }))
    }
  }, [updateMonitoringShow])

  useEffect(() => {
    if (!updateMonitoringShow) return
    if (patientMonitoringData && Object.keys(patientMonitoringData).length) {
      const arr = []
      const providerTypeRadioInitial = {}
      const defaultProvider = {}
      const defaultPractitioner = {}
      setSelectedTypes([...Object.keys(patientMonitoringData)])

      for (let key in patientMonitoringData) {
        patientMonitoringData[key].forEach(data => {
          data?.programs?.forEach((programs) => {
            arr.push({
              monitoringId: data?.monitoringId,
              programType: data?.monitoringType,
              programId: programs?.programId,
              programName: programs?.programName,
              provider_practitioner_id: `${data?.monitoringType}:${data?.providerId ?? data?.practitionerId}`,
              providerType: data?.providerId ? "provider" : "practitioner"
            })
            providerTypeRadioInitial[`${data?.monitoringType}`] =
              (data?.providerId ? "provider" : "practitioner") +
              `~${data?.monitoringType}`
            if (data?.providerId && providerList?.find(({ id }) => data?.providerId === id)) {
              defaultProvider[`${data?.monitoringType}`] = `${data?.monitoringType}:${data?.providerId}`
            } else if (data?.practitionerId && practitionerList?.find(({ id }) => data?.practitionerId === id)) {
              defaultPractitioner[`${data?.monitoringType}`] = `${data?.monitoringType}:${data?.practitionerId}`
            }
          })
        })
      }
      setSelectedRPM([...arr])
      setProviderTypeRadio(providerTypeRadioInitial)
      setProvider(defaultProvider)
      setPractitioner(defaultPractitioner)
      setSelectedProvider({ ...defaultProvider, ...defaultPractitioner })
      setCustomError([])
    }
  }, [patientMonitoringData, updateMonitoringShow, providerList, practitionerList])

  useEffect(() => {
    if (patientDiagnosticData && patientDiagnosticData.length) {
      setDiagnostics([...patientDiagnosticData])
    }
  }, [patientDiagnosticData?.length])

  useEffect(() => {
    if (patientMonitoringData) {
      handleDiagnosticValidation()
    }
  }, [selectedRPM, diagnostics])

  const handleDiagnosticValidation = callback => {
    if (selectedRPM.length) {
      const selectedProgramTypes = selectedRPM.map(i => i.programType)
      const noDeviceValidation = selectedProgramTypes.length === selectedTypes.length
      const defaultPrograms = Object?.keys(patientMonitoringData)
        .map(key => patientMonitoringData[key]?.map(i => i.programs.map((i) => i.programId)))
        .flat(Infinity)
      const arr = selectedRPM.filter(i => (!defaultPrograms.includes(i.programId) ? i : null))

      if (arr.some(i => i.provider_practitioner_id === null)) {
        setDiagnosticError(null)
        const nullProviderOrPractitionerId = arr
          .filter(i => i.provider_practitioner_id === null && !customError.includes(i.programType))
          .map(i => i.programType)
        setCustomError(prevErr => [...prevErr, ...nullProviderOrPractitionerId])
      }
      if (diagnostics.length) {
        if (
          ((selectedProgramTypes.includes("ccm") && selectedProgramTypes.includes("rpm"))
            || (selectedProgramTypes.includes("ccm") && selectedProgramTypes.includes("rtm - pain management"))
          ) &&
          diagnostics.length < 2
        ) {
          setDiagnosticError(CCM_DIAGNOSTIC_ERR_MSG)
        } else if (
          selectedProgramTypes.includes("ccm") && diagnostics.length < 2
        ) {
          setDiagnosticError(CCM_DIAGNOSTIC_ERR_MSG)
        } else if (
          selectedProgramTypes.includes("pcm") && diagnostics.length < 1
        ) {
          setDiagnosticError(PCM_DIAGNOSTIC_ERR_MSG)
        } else if (
          !selectedProgramTypes.includes("rpm") &&
          diagnostics.length === 0
        ) {
          setDiagnosticError(PCM_DIAGNOSTIC_ERR_MSG)
        } else {
          if (callback) {
            callback()
          } else {
            // setCustomError([])
            setDiagnosticError(null)
          }
        }
      } else {
        if (
          ((selectedProgramTypes.includes("ccm") && selectedProgramTypes.includes("rpm"))
            || (selectedProgramTypes.includes("ccm") && selectedProgramTypes.includes("rtm - pain management"))
          ) &&
          diagnostics.length < 2
        ) {
          setDiagnosticError(CCM_DIAGNOSTIC_ERR_MSG)
        } else if (
          selectedProgramTypes.includes("ccm") && diagnostics.length < 2
        ) {
          setDiagnosticError(CCM_DIAGNOSTIC_ERR_MSG)
        } else if (
          selectedProgramTypes.includes("pcm") && diagnostics.length < 1
        ) {
          setDiagnosticError(PCM_DIAGNOSTIC_ERR_MSG)
        } else if (
          !selectedProgramTypes.includes("rpm") &&
          diagnostics.length === 0
        ) {
          setDiagnosticError(PCM_DIAGNOSTIC_ERR_MSG)
        } else {
          setDiagnosticError(PCM_DIAGNOSTIC_ERR_MSG)
        }
      }
    } else {
      if (selectedTypes.length === 0) {
        setDiagnosticError(SELECT_MONITOR_TYPE_MSG)
      } else {
        selectedTypes.includes("rpm") || selectedRPM.includes() ?
          setDiagnosticError(SELECT_MONITOR_DEVICE_MSG)
          : setDiagnosticError(SELECT_MONITOR_TYPE_MSG)
      }
    }
  }

  // select programs
  const handleSelectedTypes = e => {
    const type = e.target.name
    let deletedValue
    if (!e.target.checked) {
      deletedValue = selectedTypes.filter(i => i === type)
    }
    let splicedValues = [...selectedTypes]
    if (deletedValue?.length) {
      const deletedValueIndex = selectedTypes?.indexOf(deletedValue[0])
      splicedValues?.splice(deletedValueIndex, 1)
      setSelectedTypes(splicedValues)
    } else {
      if (type === "pcm" && selectedTypes.includes("ccm")) {
        const ccmIndex = selectedTypes?.indexOf("ccm")
        splicedValues?.splice(ccmIndex, 1)
      } else if (type === "ccm" && selectedTypes.includes("pcm")) {
        const pcmIndex = selectedTypes?.indexOf("pcm")
        splicedValues?.splice(pcmIndex, 1)
      }
      setSelectedTypes([...splicedValues, type])
    }
    if (deletedValue && deletedValue.length) {
      const splicedRPM = selectedRPM.filter((i) => i.programType !== deletedValue[0])
      setSelectedRPM([...splicedRPM])
      let updatedProviderTypeRadio = { ...providerTypeRadio }
      delete updatedProviderTypeRadio?.[deletedValue[0]]
      setProviderTypeRadio(updatedProviderTypeRadio)
      let updatedSelectedProvider = { ...selectedProvider }
      delete updatedSelectedProvider?.[deletedValue[0]]
      setSelectedProvider(updatedSelectedProvider)
      setProvider(prev => ({ ...prev, [deletedValue[0]]: "" }))
      setPractitioner(prev => ({ ...prev, [deletedValue[0]]: "" }))
      setCustomError([...customError.filter(e => e !== deletedValue[0])])
    }
  }

  const handleProviderTypeRadio = (e) => {
    const value = e.target.value
    const device = value?.split("~")?.[1]
    setProviderTypeRadio(prev => ({ ...prev, [device]: value }))
    setProvider(prev => ({ ...prev, [device]: "" }))
    setPractitioner(prev => ({ ...prev, [device]: "" }))

    if (!customError.includes(device)) setCustomError(prev => [...prev, device])
    setSelectedRPM(prev => prev.map((data) => data?.programType === device ? { ...data, provider_practitioner_id: null } : data))
  }

  const handleProviderChange = (val, deviceName) => {
    const defaultArr = selectedRPM
    setSelectedProvider(prev => ({ ...prev, [deviceName]: val }))
    setCustomError([...customError.filter(e => e !== deviceName)])

    const updated = defaultArr.map(obj => {
      if (
        deviceName?.toLowerCase() ===
        `${obj?.programType?.toLowerCase()}`
      ) {
        customError.length
          ? setCustomError([...customError.filter(e => e !== obj.programType)])
          : null
        obj = { ...obj, provider_practitioner_id: val, providerType: "provider" }
        return obj
      } else {
        return obj
      }
    })
    setSelectedRPM([...updated])
  }

  const handlePractitionerChange = (val, deviceName) => {
    const defaultArr = selectedRPM
    setSelectedProvider(prev => ({ ...prev, [deviceName]: val }))
    setCustomError([...customError.filter(e => e !== deviceName)])

    const updated = defaultArr.map(obj => {
      if (
        deviceName?.toLowerCase() ===
        `${obj?.programType?.toLowerCase()}`
      ) {
        customError.length
          ? setCustomError([...customError.filter(e => e !== obj.programType)])
          : null
        obj = { ...obj, provider_practitioner_id: val, providerType: "practitioner" }
        return obj
      } else {
        return obj
      }
    })
    setSelectedRPM([...updated])
  }

  useEffect(() => {
    for (let key in providerTypeRadio) {
      const provider = providerTypeRadio[key].split("~")?.[0]
      const value = providerTypeRadio[key].split("~")?.[1]
      const deviceValue = selectedProvider?.[value]
      const provider_practitioner_id = deviceValue?.split(":")?.[1]
      if (provider === "practitioner") {
        if (practitionerList?.find(({ id }) => provider_practitioner_id === id)) {
          setPractitioner(prev => ({ ...prev, [value]: deviceValue }))
        } else {
          setPractitioner(prev => ({ ...prev, [value]: "" }))
        }
      } else if (provider === "provider") {
        if (providerList?.find(({ id }) => provider_practitioner_id === id)) {
          setProvider(prev => ({ ...prev, [value]: deviceValue }))
        } else {
          setProvider(prev => ({ ...prev, [value]: "" }))
        }
      }
    }
  }, [selectedProvider])

  const handleSelectedRPMDevices = (e, value, programType) => {
    if (e.target.checked) {
      const program = rpmDevices
        .map(i => i.programs.find(j => j.id === value))
        .filter(r => r !== undefined)[0]
      setSelectedRPM([
        ...selectedRPM,
        {
          monitoringId: program?.monitoringId,
          programType,
          provider_practitioner_id: selectedProvider?.[programType] ?? null,
          programId: program.id,
          programName: program.name,
          providerType: providerTypeRadio?.[programType]?.split("~")?.[0] ?? null
        }
      ])
      handleDiagnosticValidation()
    } else {
      const removed = selectedRPM
      const index = removed.findIndex(r => r.programId === value)
      if (index !== undefined || index !== null) {
        removed.splice(index, 1)
        setSelectedRPM([...removed])

        handleDiagnosticValidation()
      }
    }
    handleDiagnosticValidation()
  }

  const onSuggestionsFetchRequested = async ({ value }) => {
    const getData = await getSuggestions(value)
    let dataList = []
    const arrayToMap = getData.filter(
      dc =>
        !diagnostics?.some(({ icdCode: id2 }) => {
          return dc[0].toLowerCase() === id2.toLowerCase()
        })
    )

    arrayToMap.map(item =>
      dataList.push({
        description: item?.[1],
        icdCode: item?.[0]
      })
    )
    setSuggestions(dataList)
    handleDiagnosticValidation()
  }

  const onSuggestionsClearRequested = () => {
    setSuggestions([])
  }

  const getSuggestionValue = suggestion => {
    setDiagnostics([
      ...diagnostics,
      {
        description: suggestion.description,
        icdCode: suggestion?.icdCode,
        diagnosedDate: diagnosticDate
      }
    ])
    return (suggestion.description = "")
  }

  const handleDiagnosticsDate = (date, index) => {
    const list = [...diagnostics]
    list[index]["diagnosedDate"] = date
    setDiagnostics(list)
  }

  const onChange = (event, { newValue }) => {
    setValue(newValue)
  }

  const renderSuggestion = suggestion => <div>{suggestion?.description}</div>

  const handleDiagnosticDelete = (id, icdCode) => {
    if (icdCode) {
      setDiagnostics((selectedDiagnostics) => selectedDiagnostics.filter((diagnotic) => diagnotic?.icdCode?.toLowerCase() !== icdCode?.toLowerCase()))
    }
    if (id) {
      setDiagnostics((selectedDiagnostics) => selectedDiagnostics.filter((diagnotic) => diagnotic?.id?.toLowerCase() !== id?.toLowerCase()))
    }
    handleDiagnosticValidation()
  }

  const handleDiagnosticsSubmit = callback => {
    const filtered = diagnostics.filter(
      ({ icdCode: id1 }) => !patientDiagnosticData.some(({ icdCode: id2 }) => id1 === id2)
    )
    const filteredToDelete = patientDiagnosticData.filter(
      ({ id: id1 }) => !diagnostics.some(({ id: id2 }) => id1 === id2)
    )
    if (filtered.length) {
      const dataToSubmit = filtered.map(dd => {
        dd.diagnosedDate = moment(dd.diagnosedDate).format("YYYY-MM-DD")
        return dd
      })
      dispatch(postPatientDiagnosticsData(patientId, dataToSubmit)).then((result) => {
        if (result?.status === 200 || result?.status === 201) {
          dispatch(getPatientDiagnosticsData({ patientId }))
        }
        if (callback) {
          callback()
        }
      })
    }
    if (filteredToDelete.length) {
      filteredToDelete.map((diagnotic) => {
        if (diagnotic?.id) {
          dispatch(deletePatientDiagnosticsData(patientId, diagnotic?.id)).then((result) => {
            if (result?.status === 200 || result?.status === 201) {
              dispatch(getPatientDiagnosticsData({ patientId }))
            }
          })
        }
      })
    }
  }

  // Function to check for changes
  const findNewlyAddedProgram = (selected, defaults, mergedToDel) => {
    const newlyAdded = []

    // Step 1: Add selected items that are not in defaults
    selected.forEach((selectedItem) => {
      const match = defaults.find(
        (defaultItem) => selectedItem.programId === defaultItem.programId
      )

      if (!match) {
        // If no match is found in defaults, it's a newly added entry
        newlyAdded.push(selectedItem)
      } else {
        // Check for changes
        if (
          (selectedItem.providerType === "provider" &&
            selectedItem.provider_practitioner_id !== match.providerId) ||
          (selectedItem.providerType === "practitioner" &&
            selectedItem.provider_practitioner_id !== match.practitionerId)
        ) {
          newlyAdded.push(selectedItem)
        }
      }
    })

    // Step 2: Check mergedToDel for monitoringId matches
    selected.forEach((selectedItem) => {
      const isInNewlyAdded = newlyAdded.some(
        addedItem =>
          addedItem.programId === selectedItem.programId &&
          addedItem.provider_practitioner_id === selectedItem.provider_practitioner_id
      )

      if (
        mergedToDel.some((delItem) => delItem.monitoringId === selectedItem.monitoringId) &&
        !isInNewlyAdded
      ) {
        newlyAdded.push(selectedItem)
      }
    })

    return newlyAdded
  }  

  const handleMonitoringSubmit = async (callback) => {
    const defaultPrograms = Object.keys(patientMonitoringData)
      .map(key =>
        patientMonitoringData[key].map(i =>
          i.programs.map(programs => {
            if (i?.providerId) {
              return {                
                providerId: `${i.monitoringType}:${i.providerId}`,
                programId: programs.programId,
                monitoringId: i.monitoringId
              }
            }
            return {              
              practitionerId: `${i.monitoringType}:${i.practitionerId}`,
              programId: programs.programId,
              monitoringId: i.monitoringId
            }
          })
        )
      )
      .flat(Infinity)

    const defaultProgramsProvidersOrPractitioners = defaultPrograms.map(
      program => program?.providerId ?? program?.practitionerId
    )
    const defaultProgramsProgramIds = defaultPrograms.map((program) => program?.programId)
    const arr = selectedRPM.filter(i =>
      !defaultProgramsProvidersOrPractitioners.includes(i.provider_practitioner_id) ? i : null
    )

    // providerToBeEdited is filtering the deviceId which are same (server fetched and client selected) just provider is differnet
    const providerToBeEdited = arr.filter((program) => (defaultProgramsProgramIds.includes(program.programId) ? program : null))

    const selectedRPMIds = selectedRPM.map((program) => program?.programId)
    const removedProgram = defaultPrograms.filter(i => (!selectedRPMIds.includes(i.programId) ? i : null))

    const finalProgramToBeDeleted = [...providerToBeEdited, ...removedProgram]

      // Create a Set to keep track of unique monitoringIds
    const uniqueMonitoringIds = new Set();
      // Filter out duplicates
    const mergedMonitorToDelete = finalProgramToBeDeleted.filter(program => {
      if (!uniqueMonitoringIds.has(program?.monitoringId)) {
        uniqueMonitoringIds.add(program?.monitoringId);
        return true; 
      }
    return false;
    });
    for (const program of mergedMonitorToDelete) {
     await dispatch(deleteMonitoringData(patientId, program?.monitoringId))
    }
    const newlyAddedProgramEntries = findNewlyAddedProgram(selectedRPM, defaultPrograms, mergedMonitorToDelete)

      if (newlyAddedProgramEntries.length && newlyAddedProgramEntries.every(i => i.provider_practitioner_id !== null)) {
      await dispatch(
        postMonitoringData(
          patientId,
          newlyAddedProgramEntries.map(i => ({
            [`${i?.providerType}Id`]: i.provider_practitioner_id.split(":").pop(),
            monitoringId: i.programId
          }))
        )
      )
    } else {
      if (!newlyAddedProgramEntries.some(i => i.provider_practitioner_id)) {
        setCustomError(newlyAddedProgramEntries.map(i => (i.provider_practitioner_id === null ? i.programId : null)))
      }
    }
    dispatch(getPatientMonitoringData({ patientId }))
  }

  const handleOnSubmit = async () => {
    await handleDiagnosticValidation(async () => {
      if (!diagnosticError && !customError.length) {
        await handleDiagnosticsSubmit()
        await handleMonitoringSubmit()
        addToast(MONITORING_DIA_UPDT_MSG, {
          appearance: "success",
          autoDismiss: true
        })
        dispatch(getPatientMenuConfigAction(patientId))
        handleClose()
        setDiagnostics([])
        setDiagnosticError(null)
      } else if (customError.length) {
        scrollToElement(elementRefs, customError[0])
      }
    })
  }

  const filterOption = (input, option) =>
    (option?.label?.props?.children ?? "").toLowerCase().includes(input.toLowerCase())

  return (
    <Modal
      width={800}
      footer={null}
      open={updateMonitoringShow}
      onCancel={handleClose}
      title={<h4 className="text-xl">Update Monitoring</h4>}>
      <div className="pt-4">
        {loading || DiagnosticsLoading ? (
          <Loading />
        ) : (
          <>
            <div className="w-[95%] flex justify-between items-center">
              {rpmDevices?.map((d, index) => (
                <Checkbox
                  key={index}
                  ref={(el) => elementRefs.current[index] = el}
                  name={d.name}
                  className="uppercase"
                  disabled={
                    (d.name === "ccm" && selectedTypes?.find(i => i === "pcm")) ||
                    (d.name === "pcm" && selectedTypes?.find(i => i === "ccm"))
                  }
                  checked={selectedTypes.some(i => i === d.name)}
                  onChange={e => handleSelectedTypes(e)}
                >
                  {d.name}
                </Checkbox>
              ))}
            </div>

            {selectedTypes.map((type, index) => {
              return (
                <div key={index} className="mt-4">
                  <p className="uppercase font-semibold">{type}</p>
                  <>
                  <div className="flex gap-2">
                    {rpmDevices
                      ?.find((d) => d.name === type )
                      ?.programs?.map((p, ind) => (
                        <div key={ind} className="mt-3">
                          <Checkbox
                            key={p.id}
                            ref={(el) => {
                              (elementRefs).current[p.id] = el
                            }}
                            name={p.name}
                            className="capitalize"
                            checked={selectedRPM.some((i) => i.programId === p.id)}
                            onChange={e => handleSelectedRPMDevices(e, p.id, type)}>
                            {mapDeviceType(p.name)}
                          </Checkbox>
                        </div>
                      ))}
                  </div>
                    <div className="mt-2">
                      <p className="mb-1">Select Provider Type <span className="text-danger">*</span></p>
                      <Radio.Group onChange={handleProviderTypeRadio} value={providerTypeRadio?.[`${type}`]}>
                        <Radio value={`practitioner~${type}`}>Practitioner</Radio>
                        <Radio value={`provider~${type}`}>Provider</Radio>
                      </Radio.Group>
                    </div>
                    {!providerTypeRadio?.[`${type}`] ? (
                      <small className="text-danger">Please select a type</small>
                    ) : null}
                    <div className="w-full mt-3">
                      <FloatInput label={<><span className="uppercase">{type}</span> Practitioner</>} required >
                        <Select
                          showSearch
                          className="w-full"
                          id={`practitioner-${type}`}
                          disabled={!/practitioner/.test(providerTypeRadio?.[`${type}`])}
                          filterOption={filterOption}
                          options={getPractitionerOption(practitionerList, `${type}`)}
                          value={practitioner?.[type]}
                          searchtext={searchText}
                          onChange={e => handlePractitionerChange(e, `${type}`)}
                          onSearch={(val) => setSearchText(val)}
                          status={
                            /practitioner/.test(
                              providerTypeRadio?.[`${type}`]
                            ) && customError.includes(type)
                              ? "error"
                              : undefined
                          }
                        />
                      </FloatInput>
                      {/practitioner/.test(providerTypeRadio?.[`${type}`]) &&
                        customError.includes(type) ? (
                        <small className="text-danger">
                           Select a practitioner
                        </small>
                      ) : null}
                    </div>
                    <div className="w-100 mt-3">
                      <FloatInput label={<><span className="uppercase">{type}</span> Provider</>} required>
                        <Select
                          showSearch
                          className="w-100"
                          id={`provider-${type}`}
                          disabled={!/provider/.test(providerTypeRadio?.[`${type}`])}
                          filterOption={filterOption}
                          options={getProviderOption(providerList, `${type}`)}
                          value={provider?.[type]}
                          searchtext={searchText}
                          onChange={e => handleProviderChange(e, `${type}`)}
                          onSearch={(val) => setSearchText(val)}
                          status={
                            /provider/.test(
                              providerTypeRadio?.[`${type}`]
                            ) && customError.includes(type)
                              ? "error"
                              : undefined
                          }
                        />
                      </FloatInput>
                      {/provider/.test(providerTypeRadio?.[`${type}`]) &&
                        customError.includes(type) ? (
                        <small className="text-danger">
                          Select a provider
                        </small>
                      ) : null}
                    </div>
                  </>
                </div>
              )
            })}

            <div className="add-patient-auto-suggest mt-3 mb-3">
              <p className="fs-6 mb-1">Diagnostic Codes Search</p>
              <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={{
                  value,
                  onChange,
                  placeholder: "Type a Data"
                }}
              />
            </div>

            {patientDiagnosticData && diagnostics.length ? (
              <div className="mt-4">
                <div>
                  {diagnostics?.map((field, index) => {
                    return (
                      <div key={index} className="p-3 border-current rounded border-2 mb-3 pb-0">
                        <div className="d-flex w-100 align-items-center">
                          <Form.Group label="Name *" className="mb-3 w-100">
                            <Form.Control
                              required
                              disabled
                              name="name"
                              type="text"
                              value={field?.description}
                              placeholder="Name"
                              onChange={e => handleInputChange(e, index)}
                            />
                            <Form.Control.Feedback type="invalid" className="ms-1">
                              Diagnostics Name is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                          <div
                            onClick={() => handleDiagnosticDelete(field.id, field.icdCode)}
                            style={{ cursor: "pointer" }}
                            className="mb-3">
                            <FiMinusSquare className="fs-3 ms-2" />
                          </div>
                        </div>
                        <Form.Group label="Code *" className="mb-3 w-100">
                          <Form.Control
                            required
                            disabled
                            name="diagnosticId"
                            type="text"
                            value={field?.icdCode}
                            placeholder="Code"
                            onChange={e => handleInputChange(e, index)}
                          />
                          <Form.Control.Feedback type="invalid" className="ms-1">
                            Diagnostics Code is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Diagnostics Date *</Form.Label>
                          <DatePicker
                            selected={new Date(field?.diagnosedDate)}
                            onChange={date => {
                              handleDiagnosticsDate(date, index)
                            }}
                            dateFormatCalendar={"MMM yyyy"}
                            minDate={new Date().getFullYear() - 50}
                            maxDate={new Date()}
                            showPopperArrow={false}
                            placeholderText="Diagnostics Date"
                            className="border p-3 mb-2 rounded w-100"
                            withPortal
                          />
                          <Form.Control.Feedback
                            className="fs-6 text-uppercase fw-medium mb-3 text-danger"
                            type="invalid">
                            Diagnostics Date is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    )
                  })}
                </div>
              </div>
            ) : (
              "No Diagnostic Data Found"
            )}

            {diagnosticError ? (
              <div className="mt-4">
                <p className="text-danger font-semibold">{diagnosticError}</p>
              </div>
            ) : null}

            <div className="flex flex-wrap gap-3 mt-4">
              <Button size="large" danger onClick={handleUpdateMonitoringClose}>
                Cancel
              </Button>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                onClick={handleOnSubmit}
                loading={DiagnosticsLoading || loading}>
                Submit
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal >
  )
}

export default UpdateMonitoring
